// Website reverse engineering — browser client (docs/reverse-engineering/PLAN.md §Kontrak).
import { useQuery } from '@tanstack/react-query'
import { api } from '#/lib/api'
import type { SiteAnalysisDto, SiteRelation } from '#/lib/site/types'

export const qkSite = (planId: string) => ['site', planId] as const

export interface SiteState { analysis: SiteAnalysisDto | null; retryable: boolean | null }

/** Latest dissection of a plan; polls every 2 s while it runs. */
export function useSiteAnalysis(planId: string, enabled = true) {
  return useQuery({
    queryKey: qkSite(planId),
    queryFn: () => api<SiteState>(`/api/plan/${planId}/site`),
    enabled: Boolean(planId) && enabled,
    refetchInterval: (q) => {
      const s = q.state.data?.analysis?.status
      return s === 'queued' || s === 'running' ? 2000 : false
    },
  })
}

export interface CreateSiteInput {
  url: string
  notes?: string
  relation: SiteRelation
  language: 'en' | 'id'
  model?: string | null
  summaryMode?: 'full' | 'simple'
  workspaceId?: string
  consent: true
}
export const createSitePlan = (body: CreateSiteInput) => api<{ planId: string; workspaceId: string; analysisId: string }>('/api/plan/site', { method: 'POST', json: body })

export type SiteActionBody = { action: 'retry' } | { action: 'restart'; url: string; notes?: string; relation?: SiteRelation } | { action: 'continue' } | { action: 'skip'; idea: string }
export const siteAction = <T = { analysis?: SiteAnalysisDto; step?: number }>(planId: string, body: SiteActionBody) => api<T>(`/api/plan/${planId}/site`, { method: 'POST', json: body })

export const siteShotUrl = (planId: string, analysisId: string, n: number) => `/api/plan/${planId}/site/shot?analysis=${analysisId}&n=${n}`
